import { useEffect, useState } from "react"
import { Backdrop, CircularProgress, Box, Grid, Paper, Table, TableCell, TableHead, TableRow, TextField, Typography, TableBody, TableFooter, useMediaQuery, useTheme, Card, CardContent, Chip, Divider, Alert } from "@mui/material"
import axios from "../api/axios"
import useAuth from '../hooks/useAuth';
import ExportButtons from './ExportButtons';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

export default function InversionesAutomaticas() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

    const [desde, setDesde] = useState("");
    const [hasta, setHasta] = useState("");
    const [rows, setRows] = useState([])
    const [procesando, setProcesando] = useState(false)
    const [totalInvertido, setTotalInvertido] = useState(0)
    const [totalGanancia, setTotalGanancia] = useState(0)

    // Configuración actual
    const [inversionAutomatica, setInversionAutomatica] = useState(0)
    const [inversionTipo, setInversionTipo] = useState("")
    const [inversionMonto, setInversionMonto] = useState(0)
    const [inversionPorciento, setInversionPorciento] = useState(0)

    const { auth } = useAuth();

    useEffect(() => {
        setDesde(getDesde())
        setHasta(getHasta())
    }, [])

    useEffect(() => {
        if (desde && hasta) {
            actRows();
        }
    }, [desde, hasta])

    const getDesde = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();
        if (mm < 10) {
            mm = '0' + mm;
        }
        var today = yyyy + '-' + mm + '-01';
        return today;
    }

    const getHasta = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();

        if (mm == 12) {
            mm = 1
            yyyy++;
        } else {
            mm++;
        }

        let prox = new Date(yyyy, (mm - 1), 1);
        prox.setDate(prox.getDate() - 1)

        mm = prox.getMonth() + 1;
        yyyy = prox.getFullYear();
        let dd = prox.getDate();

        if (mm < 10) {
            mm = '0' + mm;
        }
        if (dd < 10) {
            dd = '0' + dd;
        }

        var today = yyyy + '-' + mm + '-' + dd;
        return today;
    }

    const actRows = async () => {
        setProcesando(true)
        let aRows = []
        let totalInv = 0
        let totalGan = 0
        try {
            const respuesta = await axios.post("inversiones/automaticas", {
                inversionista: auth.inversionista,
                desde: desde,
                hasta: hasta
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta == "S") {
                // Configuración
                setInversionAutomatica(data.inversion_automatica)
                setInversionTipo(data.inversion_tipo)
                setInversionMonto(data.inversion_monto)
                setInversionPorciento(data.inversion_porciento)

                // Lista de inversiones
                if (data.lista) {
                    aRows = data.lista;
                    data.lista.forEach((row) => {
                        totalInv = totalInv + parseFloat(row.monto_invertido || 0)
                        totalGan = totalGan + parseFloat(row.ganancia || 0)
                    })
                }
            }
        } catch (error) {
            console.log(error)
        }
        setRows(aRows)
        setTotalInvertido(totalInv)
        setTotalGanancia(totalGan)
        setProcesando(false)
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    // Card de configuración actual
    const renderConfiguracion = () => (
        <Paper sx={{
            p: isMobile ? 1.5 : 2.5,
            mb: 2,
            borderRadius: 2,
            boxShadow: 3,
            border: inversionAutomatica === 1 ? '2px solid #4caf50' : '2px solid #ef5350',
            background: inversionAutomatica === 1
                ? 'linear-gradient(135deg, rgba(76, 175, 80, 0.05) 0%, rgba(76, 175, 80, 0.1) 100%)'
                : 'linear-gradient(135deg, rgba(239, 83, 80, 0.05) 0%, rgba(239, 83, 80, 0.1) 100%)'
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                <AutoModeIcon sx={{ color: inversionAutomatica === 1 ? '#4caf50' : '#ef5350' }} />
                <Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ color: '#1e3a5f', fontWeight: 600 }}>
                    Configuración de Inversión Automática
                </Typography>
            </Box>
            <Divider sx={{ mb: 1.5 }} />
            <Grid container spacing={2}>
                <Grid item xs={6} sm={3}>
                    <Typography variant="caption" sx={{ color: '#718096', textTransform: 'uppercase' }}>
                        Estado
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                        {inversionAutomatica === 1 ? (
                            <>
                                <CheckCircleIcon sx={{ color: '#4caf50', fontSize: 20 }} />
                                <Typography sx={{ color: '#4caf50', fontWeight: 600 }}>Activo</Typography>
                            </>
                        ) : (
                            <>
                                <CancelIcon sx={{ color: '#ef5350', fontSize: 20 }} />
                                <Typography sx={{ color: '#ef5350', fontWeight: 600 }}>Inactivo</Typography>
                            </>
                        )}
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Typography variant="caption" sx={{ color: '#718096', textTransform: 'uppercase' }}>
                        Tipo
                    </Typography>
                    <Typography sx={{ color: '#1e3a5f', fontWeight: 600, mt: 0.5 }}>
                        {inversionTipo === 'MONTO' ? 'Monto Fijo' : inversionTipo === 'PORCIENTO' ? 'Porcentaje' : 'No configurado'}
                    </Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Typography variant="caption" sx={{ color: '#718096', textTransform: 'uppercase' }}>
                        {inversionTipo === 'MONTO' ? 'Monto' : 'Porcentaje'}
                    </Typography>
                    <Typography sx={{ color: '#d4af37', fontWeight: 700, mt: 0.5, fontSize: '1.1rem' }}>
                        {inversionTipo === 'MONTO'
                            ? `RD$ ${parseFloat(inversionMonto).toLocaleString('en-US', { minimumFractionDigits: 2 })}`
                            : inversionTipo === 'PORCIENTO'
                                ? `${inversionPorciento}%`
                                : '-'
                        }
                    </Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Typography variant="caption" sx={{ color: '#718096', textTransform: 'uppercase' }}>
                        Inversiones del Período
                    </Typography>
                    <Typography sx={{ color: '#1e3a5f', fontWeight: 700, mt: 0.5, fontSize: '1.1rem' }}>
                        {rows.length}
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    )

    // Renderizar tarjetas para vista móvil
    const renderMobileCards = () => {
        if (rows.length === 0) {
            return (
                <Alert severity="info" sx={{ mt: 2 }}>
                    No se encontraron inversiones automáticas en el período seleccionado.
                </Alert>
            )
        }
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pb: 2 }}>
                {rows.map((row) => (
                    <Card
                        key={row.id}
                        sx={{
                            border: '1px solid rgba(30, 58, 95, 0.1)',
                            borderRadius: 2,
                            boxShadow: '0 2px 8px rgba(30, 58, 95, 0.08)'
                        }}
                    >
                        <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontWeight: 600, color: '#1e3a5f', fontSize: '0.85rem' }}>
                                        {row.nombre} {row.apellido}
                                    </Typography>
                                    <Typography sx={{ color: '#718096', fontSize: '0.7rem' }}>
                                        {row.fecha} - {row.empresa}
                                    </Typography>
                                </Box>
                                <Chip
                                    label={row.estatus_inversion}
                                    size="small"
                                    sx={{
                                        fontSize: '0.65rem',
                                        height: 20,
                                        backgroundColor: row.estatus_inversion === 'ACTIVO' ? '#e8f5e9' : row.estatus_inversion === 'SALDADO' ? '#e3f2fd' : '#ffebee',
                                        color: row.estatus_inversion === 'ACTIVO' ? '#2e7d32' : row.estatus_inversion === 'SALDADO' ? '#1565c0' : '#c62828'
                                    }}
                                />
                            </Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: 1,
                                pt: 1,
                                borderTop: '1px solid rgba(30, 58, 95, 0.08)'
                            }}>
                                <Box sx={{ p: 1, background: 'rgba(30, 58, 95, 0.03)', borderRadius: 1 }}>
                                    <Typography sx={{ color: '#718096', fontSize: '0.65rem', textTransform: 'uppercase', mb: 0.5 }}>
                                        Invertido
                                    </Typography>
                                    <Typography sx={{ color: '#1e3a5f', fontWeight: 600, fontSize: '0.85rem' }}>
                                        {parseFloat(row.monto_invertido).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                    </Typography>
                                </Box>

                                <Box sx={{ p: 1, background: 'rgba(212, 175, 55, 0.05)', borderRadius: 1 }}>
                                    <Typography sx={{ color: '#718096', fontSize: '0.65rem', textTransform: 'uppercase', mb: 0.5 }}>
                                        Ganancia
                                    </Typography>
                                    <Typography sx={{ color: '#d4af37', fontWeight: 600, fontSize: '0.85rem' }}>
                                        {parseFloat(row.ganancia).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                    </Typography>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                ))}
            </Box>
        );
    };

    // Vista móvil
    if (isMobile) {
        return (
            <Box sx={{
                minHeight: "100vh",
                position: "relative",
                p: 1,
                display: 'flex',
                flexDirection: 'column'
            }}>
                {objWait()}

                {/* Header */}
                <Paper sx={{
                    p: 2,
                    mb: 1.5,
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderRadius: 2
                }}>
                    <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textAlign: 'center' }}>
                        Inversiones Automáticas
                    </Typography>
                </Paper>

                {/* Configuración */}
                {renderConfiguracion()}

                {/* Filtros de fecha */}
                <Paper sx={{
                    p: 1.5,
                    mb: 1.5,
                    borderRadius: 2,
                    border: '1px solid rgba(30, 58, 95, 0.1)'
                }}>
                    <Grid container spacing={1.5}>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Desde"
                                value={desde}
                                onChange={(event) => { setDesde(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: '0.85rem' }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Hasta"
                                value={hasta}
                                onChange={(event) => { setHasta(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: '0.85rem' }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>

                {/* Resumen */}
                <Paper sx={{ p: 1.5, mb: 1.5, background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                                Total Invertido
                            </Typography>
                            <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                                RD$ {totalInvertido.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                            </Typography>
                        </Box>
                        <Box sx={{ textAlign: 'right' }}>
                            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                                Total Ganancia
                            </Typography>
                            <Typography variant="h6" sx={{ color: '#d4af37', fontWeight: 'bold' }}>
                                RD$ {totalGanancia.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                            </Typography>
                        </Box>
                    </Box>
                </Paper>

                {/* Lista de inversiones */}
                <Box sx={{
                    flex: 1,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch'
                }}>
                    {renderMobileCards()}
                </Box>
            </Box>
        );
    }

    // Vista desktop
    return (
        <Box sx={{
            minHeight: "100vh",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            p: 3,
            pt: 4,
            backgroundColor: '#fafafb'
        }}>
            {objWait()}
            <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: 900, lg: 1100, xl: 1300 } }}>
                {/* Header */}
                <Paper sx={{
                    p: 2,
                    mb: 2,
                    borderRadius: 2,
                    boxShadow: 3,
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderBottom: '3px solid #d4af37'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        <AutoModeIcon sx={{ color: '#d4af37' }} />
                        <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, letterSpacing: 0.5 }}>
                            Consulta de Inversiones Automáticas
                        </Typography>
                    </Box>
                </Paper>

                {/* Configuración */}
                {renderConfiguracion()}

                {/* Filtros */}
                <Paper sx={{
                    p: 2.5,
                    mb: 2,
                    borderRadius: 2,
                    boxShadow: 3,
                    border: '1px solid rgba(30, 58, 95, 0.1)'
                }}>
                    <Typography variant="body2" sx={{ color: '#1e3a5f', fontWeight: 600, mb: 1.5, display: 'block', textTransform: 'uppercase' }}>
                        Filtros de Reporte
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="medium"
                                type="date"
                                label="Desde"
                                value={desde}
                                onChange={(event) => { setDesde(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="medium"
                                type="date"
                                label="Hasta"
                                value={hasta}
                                onChange={(event) => { setHasta(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                    </Grid>
                </Paper>

                {/* Resumen y Exportar */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1.5,
                    px: 1
                }}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Chip
                            label={`${rows.length} inversiones`}
                            size="medium"
                            sx={{
                                backgroundColor: 'rgba(30, 58, 95, 0.1)',
                                color: '#1e3a5f',
                                fontWeight: 600,
                                height: 32
                            }}
                        />
                        <Chip
                            label={`Total: RD$ ${totalInvertido.toLocaleString('en-US', { minimumFractionDigits: 2 })}`}
                            size="medium"
                            sx={{
                                backgroundColor: 'rgba(30, 58, 95, 0.1)',
                                color: '#1e3a5f',
                                fontWeight: 600,
                                height: 32
                            }}
                        />
                        <Chip
                            label={`Ganancia: RD$ ${totalGanancia.toLocaleString('en-US', { minimumFractionDigits: 2 })}`}
                            size="medium"
                            sx={{
                                backgroundColor: 'rgba(212, 175, 55, 0.15)',
                                color: '#b8860b',
                                fontWeight: 600,
                                height: 32
                            }}
                        />
                    </Box>
                    <ExportButtons
                        data={rows}
                        columns={[
                            { header: 'Fecha', field: 'fecha' },
                            { header: 'Cliente', field: 'nombre' },
                            { header: 'Apellido', field: 'apellido' },
                            { header: 'Empresa', field: 'empresa' },
                            { header: 'Monto Invertido', field: 'monto_invertido', type: 'money' },
                            { header: 'Balance Actual', field: 'balance_actual', type: 'money' },
                            { header: 'Ganancia', field: 'ganancia', type: 'money' },
                            { header: 'Estatus', field: 'estatus_inversion' }
                        ]}
                        filename="inversiones_automaticas"
                        title="Inversiones Automáticas"
                    />
                </Box>

                {/* Tabla de resultados */}
                {rows.length === 0 ? (
                    <Alert severity="info" sx={{ mt: 2 }}>
                        No se encontraron inversiones automáticas en el período seleccionado.
                    </Alert>
                ) : (
                    <Paper sx={{
                        borderRadius: 2,
                        boxShadow: 3,
                        overflow: 'hidden',
                        maxHeight: 550
                    }}>
                        <Box sx={{ overflow: 'auto', maxHeight: 550 }}>
                            <Table stickyHeader size="medium">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{
                                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                            color: 'white',
                                            fontWeight: 600,
                                            fontSize: isTablet ? '0.75rem' : '0.85rem',
                                            py: 1.25,
                                            borderBottom: '2px solid #d4af37'
                                        }}>Fecha</TableCell>
                                        <TableCell sx={{
                                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                            color: 'white',
                                            fontWeight: 600,
                                            fontSize: isTablet ? '0.75rem' : '0.85rem',
                                            py: 1.25,
                                            borderBottom: '2px solid #d4af37'
                                        }}>Cliente</TableCell>
                                        {!isTablet && <TableCell sx={{
                                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                            color: 'white',
                                            fontWeight: 600,
                                            fontSize: '0.85rem',
                                            py: 1.25,
                                            borderBottom: '2px solid #d4af37'
                                        }}>Empresa</TableCell>}
                                        <TableCell align="right" sx={{
                                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                            color: 'white',
                                            fontWeight: 600,
                                            fontSize: isTablet ? '0.75rem' : '0.85rem',
                                            py: 1.25,
                                            borderBottom: '2px solid #d4af37'
                                        }}>Invertido</TableCell>
                                        <TableCell align="right" sx={{
                                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                            color: 'white',
                                            fontWeight: 600,
                                            fontSize: isTablet ? '0.75rem' : '0.85rem',
                                            py: 1.25,
                                            borderBottom: '2px solid #d4af37'
                                        }}>Balance</TableCell>
                                        <TableCell align="right" sx={{
                                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                            color: '#d4af37',
                                            fontWeight: 600,
                                            fontSize: isTablet ? '0.75rem' : '0.85rem',
                                            py: 1.25,
                                            borderBottom: '2px solid #d4af37'
                                        }}>Ganancia</TableCell>
                                        <TableCell sx={{
                                            background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                            color: 'white',
                                            fontWeight: 600,
                                            fontSize: isTablet ? '0.75rem' : '0.85rem',
                                            py: 1.25,
                                            borderBottom: '2px solid #d4af37'
                                        }}>Estatus</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => (
                                        <TableRow key={row.id} hover sx={{ '&:hover': { backgroundColor: 'rgba(44, 82, 130, 0.04)' } }}>
                                            <TableCell sx={{ color: '#1e3a5f', fontSize: isTablet ? '0.75rem' : '0.875rem', py: 1 }}>{row.fecha}</TableCell>
                                            <TableCell sx={{ color: '#1e3a5f', fontSize: isTablet ? '0.75rem' : '0.875rem', py: 1 }}>{row.nombre} {row.apellido}</TableCell>
                                            {!isTablet && <TableCell sx={{ color: '#4a5568', fontSize: '0.875rem', py: 1 }}>{row.empresa}</TableCell>}
                                            <TableCell align="right" sx={{ color: '#1e3a5f', fontSize: isTablet ? '0.75rem' : '0.875rem', py: 1 }}>
                                                {parseFloat(row.monto_invertido).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell align="right" sx={{ color: '#4a5568', fontSize: isTablet ? '0.75rem' : '0.875rem', py: 1 }}>
                                                {parseFloat(row.balance_actual).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell align="right" sx={{ color: '#d4af37', fontWeight: 600, fontSize: isTablet ? '0.75rem' : '0.875rem', py: 1 }}>
                                                {parseFloat(row.ganancia).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell sx={{ py: 1 }}>
                                                <Chip
                                                    label={row.estatus_inversion}
                                                    size="small"
                                                    sx={{
                                                        fontSize: '0.7rem',
                                                        backgroundColor: row.estatus_inversion === 'ACTIVO' ? '#e8f5e9' : row.estatus_inversion === 'SALDADO' ? '#e3f2fd' : '#ffebee',
                                                        color: row.estatus_inversion === 'ACTIVO' ? '#2e7d32' : row.estatus_inversion === 'SALDADO' ? '#1565c0' : '#c62828'
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <TableFooter>
                                    <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                                        <TableCell colSpan={isTablet ? 2 : 3} sx={{ fontWeight: 600, color: '#1e3a5f', fontSize: '0.875rem', py: 1.5 }}>
                                            {"Total: " + rows.length + " inversiones automáticas"}
                                        </TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 700, color: '#1e3a5f', fontSize: '0.875rem', py: 1.5 }}>
                                            {totalInvertido.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell></TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 700, color: '#d4af37', fontSize: '0.875rem', py: 1.5 }}>
                                            {totalGanancia.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </Box>
                    </Paper>
                )}
            </Box>
        </Box>
    )
}
